import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {clone, pick, has, get} from 'lodash';

import API from '../lib/api';
import i18n from 'i18n';

import UploadAvatarContainer from './upload-avatar-container';
import {DateLabel} from 'modules/shared/components';

import deepLinkState from '../mixins/deepLinkState';
import {linkMixin} from '../lib/mixins';

const SettingsAccountContentReadOnly = createClass({
  propTypes: {
    user: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onSave: PropTypes.func
  },

  mixins: [deepLinkState, linkMixin],

  getInitialState() {
    const initialUserData = clone(this.props.user);
    const {
      _id: id,
      name,
      lastName,
      gender,
      profileImage,
      birthday = ''
    } = initialUserData;

    return {
      userData: {id, name, lastName, birthday, gender, profileImage},
      avatarUrl: '',
      showErrors: false
    };
  },

  validateData(userData) {
    const {user} = this.props;
    const requireInfluencerInputs = user.role === 'influencer';
    let isValid = true;
    isValid = isValid && this.validateName(userData);
    if (requireInfluencerInputs) {
      isValid = isValid && this.validateGender(userData);
      isValid = isValid && this.validateBirthday(userData);
    }
    return isValid;
  },

  validateName(userData) {
    const {name = ''} = userData;
    return name.trim().length > 0;
  },

  validateGender(userData) {
    const {gender} = userData;
    return !!gender;
  },

  validateBirthday(userData) {
    const {birthday} = userData;
    return !!birthday;
  },

  onNameChange(event) {
    const name = event.target.value;
    const {userData} = this.state;
    const newUserData = Object.assign({}, userData, {name});
    this.setState({
      userData: newUserData
    });
  },

  onLastNameChange(event) {
    const lastName = event.target.value;
    const {userData} = this.state;
    const newUserData = Object.assign({}, userData, {lastName});
    this.setState({
      userData: newUserData
    });
  },

  onDateChange(birthday) {
    const {userData} = this.state;
    const newUserData = Object.assign({}, userData, {birthday});
    this.setState({
      userData: newUserData
    });
  },

  onGenderChange(event) {
    var state = this.state;
    state.userData.gender = event.target.getAttribute('data-value');
    this.setState(state);
  },

  onSelectImage(id, image) {
    const {userData} = this.state;
    const updateData = {id: userData.id, profileImage: image};
    const newUserData = Object.assign({}, userData, updateData);
    this.setState({
      userData: newUserData
    });

    API.auto('updateUser', updateData, {});
  },

  saveData() {
    const {userData} = this.state;
    const isValid = this.validateData(userData);
    const storeData = pick(userData, ['id', 'name', 'lastName', 'birthday', 'gender', 'profileImage']);

    if (!isValid) return this.setState({showErrors: true});

    API.auto('updateUser', storeData, {
      successMessage: 'Se ha guardado con éxito',
      callback: (err) => {
        if (err) return console.error(err);
        if (has(this.props, 'onSave')) this.props.onSave();
      }
    });
  },

  getGender() {
    const gender = get(this.state, 'userData.gender');
    if (!gender) return i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_GENDER_NOT_SPECIFIED');
    return gender === 'male' ? i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_GENDER_MALE') : i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_GENDER_FEMALE');
  },

  render() {
    const {userData} = this.state;
    const {name, lastName, profileImage, birthday} = userData;

    return (
      <div className='vf-row'>
        <div className='col-xs-12 col-md-4 vf-settings-avatar' id='avatar-container'>
          <UploadAvatarContainer
            image={profileImage}
            onChange={this.onSelectImage}
            label={i18n.get('INF_SETTINGS_ACCOUNT_UPLOAD_BUTTON_LABEL')}
          />
        </div>
        <div className='col-xs-12 col-md-4'>
          <div className='vf-descriptor'>
            {i18n.get('INF_SETTINGS_ACCOUNT_PERSONAL_FIRST_NAME_LABEL')}
          </div>
          <h4 data-uitest='name'>{name}</h4>

          <div className='vf-descriptor margin-top-1x'>
            {i18n.get('INF_SETTINGS_ACCOUNT_PERSONAL_BIRTHDATE_LABEL')}
          </div>
          <span data-uitest='birthdate'>
            <DateLabel date={birthday} />
          </span>
        </div>

        <div className='col-xs-12 col-md-3'>
          <div className='vf-descriptor'>
            {i18n.get('INF_SETTINGS_ACCOUNT_PERSONAL_LAST_NAME_LABEL')}
          </div>
          <h4 data-uitest='lastname'>{lastName || '--'}</h4>

          <div className='vf-descriptor margin-top-1x'>
            {i18n.get('INF_SETTINGS_ACCOUNT_PERSONAL_GENDER_LABEL')}
          </div>
          <h4 data-uitest='gender'>{this.getGender()}</h4>
        </div>
      </div>
    );
  }
});

module.exports = SettingsAccountContentReadOnly;
